import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import TaskTimerEditRequest from '../../../projects/task-timer/i-service/model/TaskTimerEditRequest';
import TaskTimerCloseTimerRequest from '../../../projects/task-timer/i-service/model/TaskTimerCloseTimerRequest';
import GetListRequest from '../../../projects/task-timer/i-service/model/GetListRequest';
import TimerCreateRequest from '../../../projects/task-timer/i-service/model/TimerCreateRequest';
import TimerStartRequest from '../../../projects/task-timer/i-service/model/TimerStartRequest';
import CurrnetLastTimerRequest from '../../../projects/task-timer/i-service/model/CurrnetLastTimerRequest';
import TaskTimerDeleteRequest from '../../../projects/task-timer/i-service/model/TaskTimerDeleteRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import GetListResponse from '../../../projects/task-timer/i-service/model/GetListResponse';
import TaskTimerStartTimerResult from '../../../projects/task-timer/i-service/model/TaskTimerStartTimerResult';
import CurrnetLastTimerResponse from '../../../projects/task-timer/i-service/model/CurrnetLastTimerResponse';
import OnStopTimerResponse from '../../../projects/task-timer/i-service/model/OnStopTimerResponse';

/**
 * * Сервис для работы с таймерами задач
 */
export default class TaskTimersService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Событие запуска таймера
	 */
	OnStartTimerEvent = new Events<WsResponseModelT<CurrnetLastTimerResponse>>();
	/**
	 * * Событие запуска таймера
	 */
	OnStopTimerEvent = new Events<WsResponseModelT<OnStopTimerResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('TaskTimersService', 'OnStartTimer', 'Main', (res: WsResponseModelT<CurrnetLastTimerResponse>) => {
			self.OnStartTimerEvent.trigger(res);
		});
		webApiService.on('TaskTimersService', 'OnStopTimer', 'Main', (res: WsResponseModelT<OnStopTimerResponse>) => {
			self.OnStopTimerEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Изменить время начала и конца
	 */
	async Edit(request: TaskTimerEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'Edit',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поставить дату окончания текушей
	 */
	async StopTimer(request: TaskTimerCloseTimerRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'StopTimer',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Поиск по TaskId
	 */
	async GetList(request: GetListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'GetList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Создание таймера
	 */
	async TimerCreate(request: TimerCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'TimerCreate',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Запуск таумера
	 */
	async TimerStart(request: TimerStartRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'TimerStart',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Время последнего таймера
	 */
	async CurrnetLastTimer(request: CurrnetLastTimerRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'CurrnetLastTimer',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить таймер
	 */
	async Delete(request: TaskTimerDeleteRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'TaskTimersService',
			Method: 'Delete',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Изменить время начала и конца
	 */
	async editAsync(request: TaskTimerEditRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'Edit',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поставить дату окончания текушей
	 */
	async stopTimerAsync(request: TaskTimerCloseTimerRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'StopTimer',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Поиск по TaskId
	 */
	async getListAsync(request: GetListRequest): Promise<GetListResponse> {
		return new Promise<GetListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'GetList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Создание таймера
	 */
	async timerCreateAsync(request: TimerCreateRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'TimerCreate',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Запуск таумера
	 */
	async timerStartAsync(request: TimerStartRequest): Promise<TaskTimerStartTimerResult> {
		return new Promise<TaskTimerStartTimerResult>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'TimerStart',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<TaskTimerStartTimerResult>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as TaskTimerStartTimerResult)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Время последнего таймера
	 */
	async currnetLastTimerAsync(request: CurrnetLastTimerRequest): Promise<CurrnetLastTimerResponse> {
		return new Promise<CurrnetLastTimerResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'CurrnetLastTimer',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<CurrnetLastTimerResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as CurrnetLastTimerResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить таймер
	 */
	async deleteAsync(request: TaskTimerDeleteRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'TaskTimersService',
				Method: 'Delete',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}